import { Component } from '@angular/core';

@Component({
  selector: 'app-banner-description',
  templateUrl: './banner-description.component.html',
  styleUrls: ['./banner-description.component.scss']
})
export class BannerDescriptionComponent {

}
